export default {
  // Navigation
  nav_concept: "コンセプト",
  nav_features: "特徴",
  nav_details: "詳細",
  nav_content: "授業内容",
  nav_tuition: "料金",
  nav_instructor: "講師紹介",
  nav_voices: "体験者の声",
  nav_faq: "よくある質問",
  nav_register: "お申し込み",
  nav_about: "J-Motionについて",
  nav_contact: "お問い合わせ",
  
  // Hero Section
  hero_title: "J-Motion Academy — Learn in Motion. Live the language.",
  hero_subtitle: '遊び・アクション・コミュニケーションを通して"体感しながら学ぶ"言語クラス。',
  hero_cta: "無料体験クラス申し込み",
  
  // Concept
  concept_title: "コンセプト",
  concept_text1: "子どもは 動く・遊ぶ・関わる ことで言語をもっとも自然に吸収します。",
  concept_text2: "J-Motion Academyは座って暗記するクラスではありません。",
  concept_text3: '"動きの中で自然に身につく"アクティブ言語クラス です。',
  
  // Why J-Motion Academy
  why_jmotion_title: "なぜ J-Motion Academy？",
  founder_title: "創設者 Haru（春野真理）について",
  founder_text1: "Haru（春野真理）は、20年以上にわたり発達障害のある子どもや大人のサポート、指導を行ってきました。",
  founder_text2: "その中で、机と椅子を並べ、教科書と鉛筆で学ぶクラシックな学び方だけが学習方法ではないと確信しました。",
  method_title: "J-Motionの学び方",
  method_text1: "脳科学に基づき、五感をフル活用して学ぶ体験型レッスンでは、頭だけでなく全身で言語を体得できます。楽しみながら自然に覚えられるので、言語が体の中でイキイキと飛び跳ねる感覚になり、この記憶は一生残ります。",
  method_text2: "このメソッドは日本語でも英語でも応用可能で、特に発達の個性が強い人にとって、心地よく楽しく自然に学べる機会を提供します。",
  
  // J-Motion Academy Programs
  academy_programs_title: "J-Motion Academyについて",
  academy_intro: "J-Motion Academyは、年齢や目的に応じた4つの部門で構成されています：",
  academy_kids: "J-Motion Kids：3歳から12歳が対象",
  academy_youth: "J-Motion Youth：13歳から18歳が対象",
  academy_japanese: "J-Motion Japanese：大人の方が対象",
  academy_english: "J-Motion English：子供、大人それぞれに日本語で英語を学びたい人が対象",
  
  // Features
  features_title: "特徴",
  
  // Lesson Highlights
  lesson_highlights_title: "レッスンのポイント",
  highlight1_title: "五感をフル活用",
  highlight1_desc: "話す・聞く・見る・触る",
  highlight2_title: "アクティブな学習",
  highlight2_desc: "受け身ではなく、自分から動く",
  highlight3_title: "体で体得",
  highlight3_desc: "言語を頭で覚えるだけでなく、体で体得",
  highlight4_title: "自然に記憶に定着",
  highlight4_desc: "楽しみながら自然に記憶に定着",
  
  feature1_title: "体を使って学ぶムーブメント学習",
  feature1_desc: "動きながら、演じながら、遊びながら学びます。",
  feature2_title: "少人数制でしっかりサポート",
  feature2_desc: "一人ひとりに丁寧な指導が行き届きます。",
  feature3_title: "日本語/英語経験ゼロでもOK",
  feature3_desc: "初めてでも安心して参加できます。",
  feature4_title: "英語サポートあり／インクルーシブ対応",
  feature4_desc: "多様な学習スタイルに対応しています。",
  feature5_title: '日常で使える"生きた日本語/英語"が身につく自信アップ型クラス',
  feature5_desc: "子どもたちが日本語/英語を使うことに自信を持てるようになります。",
  
  // Details
  details_title: "場所・日程",
  details_location: "場所：",
  details_location_value: "対面はトロント、オンライン受講もできます。",
  details_trial: "無料体験：",
  details_trial_value: "無料体験クラスをご用意しています",
  details_start: "開講：",
  details_start_value: "随時（日程は応相談）",
  
  // Class Content
  content_title: "クラス内容",
  content_subtitle: "クラス内容の例：",
  content_item1: "日本語/英語での指示ゲーム",
  content_item2: "フラッシュカード＆ムーブメント",
  content_item3: "リズム・歌・動作を使った日本語/英語",
  content_item4: "季節のクラフト",
  content_item5: "実生活で使えるコミュニケーション練習",
  content_goal: "目的：",
  content_goal_text: "日本語/英語を「勉強」ではなく 自然な体験 として身につけること。",
  
  // Lesson Plans
  lesson_plans_title: "レッスンプラン例",
  lesson_25_title: "25分レッスン（Short Session）",
  lesson_25_step1_title: "Warm-up（5分）",
  lesson_25_step1_desc: "指示ゲームやミニ体操で体を動かす",
  lesson_25_step2_title: "新しい言語の導入（10分）",
  lesson_25_step2_desc: "見て触って体験、絵やカードで理解",
  lesson_25_step3_title: "アクティビティ（7分）",
  lesson_25_step3_desc: "ペアや小グループで実践",
  lesson_25_step4_title: "Review & Wrap-up（3分）",
  lesson_25_step4_desc: "今日覚えた言葉を確認",
  
  lesson_50_title: "50分レッスン（Full Session）",
  lesson_50_step1_title: "Warm-up（5分）",
  lesson_50_step1_desc: "動きながら言語を刺激",
  lesson_50_step2_title: "新しい単語・文法導入（15分）",
  lesson_50_step2_desc: "五感を使った体験型活動",
  lesson_50_step3_title: "ペア/グループアクティビティ（15分）",
  lesson_50_step3_desc: "ロールプレイやゲーム",
  lesson_50_step4_title: "応用練習（10分）",
  lesson_50_step4_desc: "実際の場面を想定して使う",
  lesson_50_step5_title: "Review & Wrap-up（5分）",
  lesson_50_step5_desc: "今日の振り返り、質問タイム",
  
  // Homework
  homework_title: "宿題例",
  homework_item1: "今日の単語・フレーズをイラストやジェスチャーで表現",
  homework_item2: "簡単な会話文を自分で音読、録音して提出",
  homework_item3: "自宅で家族や友達とミニゲームをして練習",
  
  // Tuition
  tuition_title: "料金",
  tuition_contact_message: "料金に関しては、別途お問い合わせください。",
  
  // Instructor
  instructor_title: "講師紹介",
  instructor_name: "名前：Haru（春野真理）",
  instructor_education_title: "学歴・資格",
  instructor_education1: "明治大学大学院農芸化学専攻修士課程卒業",
  instructor_education2: "George Brown College Behaviour Science Program卒業",
  instructor_education3: "Special Needs Educator License保持",
  
  instructor_career_title: "経歴",
  instructor_career1: "2002年より教育現場に携わり、特に発達障害、不登校児童に力を注ぐ。",
  instructor_career2: "2016年よりカナダのトロントに拠点を移し日本人向けだけではなくカナダ、世界中の人に向けて指導を広げる。",
  instructor_career3: "2019年J-Motion Academyの前身となるHaru's Bilingual Schoolを立ち上げる。",
  instructor_career4: "2025年J-Motion Academyの中で、Kids部門、Youth部門、Japanese(Adult)部門、English部門を立ち上げる。",
  
  instructor_personal_title: "Haruについて",
  instructor_favorite_food: "好きな食べ物：ザクロ、Avocadoサラダ",
  instructor_favorite_color: "好きな色：紫",
  instructor_favorite_phrase: "好きな言葉：GIVE IT A SHOT!!",
  instructor_personality: "性格：超ポジティブ、一度始めたことは長く続けられる、「続ける」才能の持ち主。大雑把。",
  
  instructor_episodes_title: "Haruのプチエピソード",
  instructor_episode1: "大学院生の時に、不慮の事故に遭い、全身大やけどを負い、九死に一生を得る。理系の道を閉ざされ、楽天に就職、数万人の営業マンの中でトップをひた走る。",
  instructor_episode2: "東京のど真ん中の交差点で道路に飛び出した男の子がトラックにはねられそうな状況で彼を助け出し、代わりに自分がはねられ、後頭部25針を縫い、ろっ骨が折れ、歯を全部失う悲惨な状況に追い込まれるも再び九死に一生を得る。",
  instructor_episode3: "不登校8年、引きこもりだった子に対してHaruが指導を始めて半年、彼が「ハル先生に会いにトロントに行きたい！」と言い出し2週間の留学を実現。日本帰国後は高校に戻り、大学進学を目指すという大きな成長を遂げた。",
  instructor_episode4: "ADHDで学校の授業に全然集中できず、日本語学校に4年通っても自宅で一切日本語が出てこなかった子がHaruのグループレッスンに参加した初日、その直後から日本語でHaruに倣った歌を口ずさむようになり、日本語を学びたい意欲がぐんぐんあがっていった。",
  
  instructor_dream_title: "Haruの夢",
  instructor_dream: "集中力を高めたり、創造力を養うことからこの世の中に自信と生き抜く力を身に着けた世界で活躍できる「地球人」を育てていくこと。教室に机と椅子を並べるクラッシックな授業スタイルではなく、脳科学を取り入れた、机、椅子、教科書、鉛筆の代わりにトランポリンやカラーコーン、ラダーなどを用いて全身と五感を用いたメソッドを用いた授業スタイルを世界中に広めていきたい。",
  
  // Parent Voices
  voices_title: "体験者の声",
  voice1: "家でもすぐに日本語/英語のフレーズを口にするようになりました！",
  voice2: "動きながら学ぶスタイルがうちの子にぴったりでした！",
  voice3: "Haru先生のテンションがとても高いのでどんなに落ち込んで家に帰って来た日でも絶対に欠かさず受講したいといつも思っています。教科書では学べない本当に生きた、現地で使える英語が身につくのがうれしくて海外出張に行くのが億劫でなくなりました。",
  voice4: "トロント渡航前、自分でできることからやりたいと思ったけれど、何から手を付けたらいいかわからず、Haru先生の留学準備前英語プログラムを受講したところ、今自分が何ができていて何が弱いのか、明確になり、渡航直前まで続け、渡航後、英語でコミュニケーションをとることに一切抵抗がなかったです。",
  voice5: "勉強が大嫌いで机に１０分と向かっていられない私が、毎週５０分のクラスを７年も続けていられるのは紛れもなくHaru先生の超ポジティブなエネルギーと本当に飽きさせないその生徒一人一人にあったご指導のおかげです。Haru先生には感謝してもしきれないです。これからも一生Haru先生のレッスンを受講し続けたいです。",
  voice6: "日本語を教科書片手に学び始めて数年たっても一向に上達しない自分にいら立ち、もうあきらめようと思っていた矢先にHaru先生に出会うことができました。教科書ではなく、ネイティブの生きた日本語が全身で吸収していける感覚に衝撃を受けました。全身で日本語を学ぶこの感覚、みんなに体験してもらいたいです。",
  
  // Registration
  registration_title: "申し込み",
  registration_text: "無料体験クラスのお申込みは下記よりどうぞ。",
  registration_cta: "無料体験クラス申し込み",
  
  // Form Fields
  form_parent_name: "保護者名",
  form_child_name: "お子様のお名前",
  form_child_age: "お子様の年齢",
  form_select_age: "年齢を選択",
  form_email: "メールアドレス",
  form_phone: "電話番号（任意）",
  form_trial_date: "希望の体験日",
  form_select_date: "希望日を選択",
  form_weekdays_3pm: "平日 午後3時",
  form_saturday_2pm: "土曜日 午後2時",
  form_sunday_10am: "日曜日 午前10時",
  form_japanese_level: "お子様の日本語/英語レベル",
  form_select_level: "レベルを選択",
  form_level_no_experience: "No experience / 初めて",
  form_level_beginner: "Beginner / 初級",
  form_level_can_speak_little: "Can speak a little / 少し話せる",
  form_level_can_understand: "Can understand simple Japanese/English / 少し理解できる",
  form_additional_info: "お子様について知っておくべきこと（任意）",
  form_hear_about_us: "どこで知りましたか（任意）",
  form_submitting: "送信中...",
  form_success: "ありがとうございます！お申し込みを受け付けました。",
  form_error: "エラーが発生しました。もう一度お試しください。",
  
  // FAQ
  faq_title: "よくある質問",
  faq_q1: "日本語/英語が全くできませんが大丈夫？",
  faq_a1: "はい！英語と日本語を使いながらゆっくり進めます。",
  faq_q2: "保護者は見学できますか？",
  faq_a2: "可能です。無料トライアルではもちろんご見学いただけますし、その後の授業も見学席をご準備いたしますので使っていただくことも可能です。",
  faq_q3: "動きが多いと危なくないですか？",
  faq_a3: "安全に配慮した簡単なアクティビティのみを行います。",
  
  // Final CTA
  final_title: "自分がもう大丈夫と準備万端になるまで待つ必要ありません。最初の一歩を踏み出すことに意味があります。GIVE IT A SHOT!! ぜひお待ちしています。",
  final_cta: "無料体験",
  
  // Footer
  footer_copyright: "© 2025 J-Motion Academy. All rights reserved.",
  footer_link: "Website Builder",

  // About J-Motion Page
  about_hero_title: "なぜ J-Motion Academy？",
  about_hero_subtitle: "体も心も頭も、全身で学ぶ体験型レッスン",
  
  about_founder_title: "創設者 Haru（春野真理）について",
  about_founder_text1: "Haru（春野真理）は、20年以上にわたり発達障害のある子どもや大人のサポート、指導を行ってきました。",
  about_founder_text2: "その中で、机と椅子を並べ、教科書と鉛筆で学ぶクラシックな学び方だけが学習方法ではないと確信しました。",
  
  about_method_title: "J-Motionの学び方",
  about_method_text1: "脳科学に基づき、五感をフル活用して学ぶ体験型レッスンでは、頭だけでなく全身で言語を体得できます。",
  about_method_text2: "楽しみながら自然に覚えられるので、言語が体の中でイキイキと飛び跳ねる感覚になり、この記憶は一生残ります。",
  about_method_text3: "このメソッドは日本語でも英語でも応用可能で、特に発達の個性が強い人にとって、心地よく楽しく自然に学べる機会を提供します。",
  
  about_highlights_title: "レッスンのポイント",
  about_highlight1: "五感をフル活用：話す・聞く・見る・触る",
  about_highlight2: "受け身ではなく、自分から動くアクティブな学習",
  about_highlight3: "言語を頭で覚えるだけでなく、体で体得",
  about_highlight4: "楽しみながら自然に記憶に定着",
  
  about_lesson_plans_title: "レッスンプラン例",
  about_short_lesson: "25分レッスン（Short Session）",
  about_short_warmup: "Warm-up（5分）: 指示ゲームやミニ体操で体を動かす",
  about_short_intro: "新しい言語の導入（10分）: 見て触って体験、絵やカードで理解",
  about_short_activity: "アクティビティ（7分）: ペアや小グループで実践",
  about_short_review: "Review & Wrap-up（3分）: 今日覚えた言葉を確認",
  
  about_full_lesson: "50分レッスン（Full Session）",
  about_full_warmup: "Warm-up（5分）: 動きながら言語を刺激",
  about_full_intro: "新しい単語・文法導入（15分）: 五感を使った体験型活動",
  about_full_activity: "ペア/グループアクティビティ（15分）: ロールプレイやゲーム",
  about_full_practice: "応用練習（10分）: 実際の場面を想定して使う",
  about_full_review: "Review & Wrap-up（5分）: 今日の振り返り、質問タイム",
  
  about_homework_title: "宿題例",
  about_homework1: "今日の単語・フレーズをイラストやジェスチャーで表現",
  about_homework2: "簡単な会話文を自分で音読、録音して提出",
  about_homework3: "自宅で家族や友達とミニゲームをして練習",
  
  about_cta_title: "J-Motionの違いを体験してください",
  about_cta_text: "無料体験クラスで、動きが言語学習をどう変えるかを発見してください。",
  about_cta_button: "無料体験を予約"
};
